<template>
  <v-card title="年假维护">
    <v-modal
      title="提示信息"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
            
      <p>{{ message }}</p>
          </v-modal
    >
    <div class="grid-demo">
      <v-form slot="form">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="8">
            <div style="text-align: left">
              <v-form-item label="导入模板">
                <a href="../../../static/other/年假导入.xlsx"
                  >年假导入.xlsx</a
                >
              </v-form-item>
              <v-upload
                :action="action"
                :accept="xml"
                multiple
                @change="onChange"
              >
                <v-button type="ghost">
                  <v-icon type="upload"></v-icon>点击上传
                </v-button>
              </v-upload>
            </div>
          </v-col>
          <v-col class="gutter-row" span="16">
            <div style="text-align: right">
              <v-form-item>
                <v-input placeholder="输入工号或姓名" v-model="cx"></v-input>
              </v-form-item>
              <v-form-item>
                <v-button type="primary" icon="search" @click="findList()"
                  ><span>检索</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
    >
      <!--自定义插槽 cz-->
      <template v-slot:cz="{ row }">
        <span>
          <span>
            <a class="link" @click="add(row)" title="修改">
              <v-icon type="edit"></v-icon>
            </a>
          </span>
        </span>
      </template>
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
  </v-card>
</template>
<script>
let options = {
  id: ""
};
export default {
  data() {
    return {
      options,
      checked: true,
      tableData: [],
      xml: ".xlsx",
      action: "api/system/ryjqwh/upload-ryjqwh-list",
      cx: "",
      message: "",
      visible: false,
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 408,
        headerAlign: "center",
        checkboxConfig: {
          labelField: "id",
          highlight: true,
          range: true,
        },
        editConfig: {
          trigger: "", //click可以编辑表格
          mode: "row",
          showStatus: true,
        },
        columns: [
          {
            type: "seq",
            title: "序号",
            width: 70,
            align: "center",
          },
          {
            field: "gh",
            title: "工号",
            align: "center",
          },
          {
            field: "xm",
            title: "姓名",
            align: "center",
          },
          {
            field: "xjlx_mc",
            title: "假期类型",
            align: "center",
          },
          {
            field: "qsrq",
            title: "起始时间",
            align: "center",
          },
          {
            field: "jzrq",
            title: "截至时间",
            align: "center",
          },
          {
            field: "zs",
            title: "总天数",
            align: "center",
          },
          {
            field: "cz",
            title: "操作",
            align: "center",
            slots: {
              // 对应自定义插槽的名称
              default: "cz",
            },
          },
        ],
      },
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.$axios.get("api/system/ryjqwh/get-ryjqwh-list?cx=" + this.cx).then((res) => {
        this.tableData = res.data.data;
      });
    },
    add: function(row) {
      let id = row.id;
      let title = "修改年假";
      xadmin.open(title, "/ryjqwhadd?id=" + id, "600", "500");
    },
    onChange(info) {
      if (info.file.response) {debugger;
        if(info.file.response.code == "200"){
          //this.$message['success'](info.file.response.message);
          this.message = info.file.response.message;
          this.showModal();
          this.findList();
        }
        else {
          //this.$message['error'](info.file.response.message);
          this.message = info.file.response.message;
          this.showModal();
      }
      } 
    },
    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/jcsj/ryjqwh.vue